(function () {
  let angular = window.angular;

  Controller.$inject = [
    '$rootScope',
    '$scope',
    '$element',
    '$uibModal',
    '$translate',
    '$timeout',
    'Customer',
    'Var',
    'AgGridService',
    'AppUtils',
  ];

  angular.module('app').component('telegramPermissionsTable', {
    template:'<div style="position: relative" ng-if="ctrl.isAdmin || (!ctrl.isAdmin && ctrl.botIsCreated)"><div class="panel panel-default"><header class="panel-heading"><h2 class="nowrap"><strong translate>entities.telegram.title</strong></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar" ng-if="ctrl.telegramIntegration"><button class="btn btn-primary" ng-click="ctrl.changeTelegramIntegration()">{{ctrl.buttonText}}</button> <button ng-if="ctrl.telegramIntegration" class="btn btn-primary" ng-click="ctrl.createPermission()" translate>entities.telegram.actions.addPermission</button></div></div></header><div ng-if="!ctrl.telegramIntegration && !ctrl.loading" class="alert alert-info text-center no-margin"><button class="btn btn-primary btn-lg" ng-click="ctrl.changeTelegramIntegration()">{{ctrl.buttonText}}</button></div><div class="alert alert-warning no-margin text-center" ng-if="ctrl.activationError">{{ctrl.activationError}}</div><div ng-show="ctrl.telegramIntegration && !ctrl.loading" class="panel-body no-padding"><div class="asset-profile no-border no-margin"><div class="asset-profile-right" style="margin-left: 0px"><div class="asset-name"><h2 translate>entities.telegram.bot.title</h2></div><div class="responsive-table"><table class="table no-margin table-description"><thead><tr><th colspan="4" class="no-padding"></th></tr></thead><tbody><tr class="bordered"><td class="field" translate>entities.telegram.bot.link</td><td data-label="link" class="clipboard"><a href="{{\'https://\'+ctrl.data.link}}">{{ctrl.data.link}}</a><button class="btn btn-default btn-sm btn-clipboard" clipboard title="Copy to clipboard" data-text="ctrl.data.link"><i class="fas fa-copy"></i></button></td></tr><tr class="bordered"><td class="field" style="width: 160px" translate>entities.telegram.bot.activationCode</td><td data-label="hashedCode" class="clipboard">{{ctrl.data.hashedCode}} <button class="btn btn-default btn-sm btn-clipboard" clipboard title="Copy to clipboard" data-text="ctrl.data.hashedCode"><i class="fas fa-copy"></i></button></td></tr></tbody></table></div><hr class="marginT0"><div class="asset-name marginB0"><h2 translate>entities.telegram.titles.userPermissions</h2></div></div></div><div class="ag-theme-custom" id="permission-table"></div></div><div style="position: relative; height: 200px" ng-show="ctrl.loading"><spinner css-class="\'small\'" show="ctrl.loading"></spinner></div></div></div>',
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      project: '<',
    },
  });

  function Controller(
    $root,
    $scope,
    $element,
    $uibModal,
    $translate,
    $timeout,
    Customer,
    Var,
    AgGridService,
    utils
  ) {
    let vm = this;
    vm.$onInit = function onInit() {
      vm.loading = true;
      vm.changeTelegramIntegration = changeTelegramIntegration;
      vm.createPermission = createPermission;
      vm.isAdmin = $root.isAdmin | $root.isSuperAdmin;
      vm.botIsCreated = false;

      Customer.prototype$__get__projects__telegramPermissions({
        id: vm.project.customerId,
        nk: vm.project.id,
      })
        .$promise.then((data) => {
          vm.botIsCreated = true;
          if (!vm.isAdmin) {
            data.permissions = data.permissions.filter(function (permission) {
              return permission.userType === 'Manager';
            });
          }
          vm.data = data;
          vm.telegramIntegration = vm.data.created && vm.data.working;
          getEmails().then(() => {
            vm.data.permissions.forEach((permission, i) => {
              vm.data.permissions[i].email = vm.usersEmails[vm.data.permissions[i].vsaasUserId];
            });

            setButtonText(vm.telegramIntegration);
            vm.loading = false;
            initTable(vm.data.permissions);
          });
        })
        .catch((data) => {
          vm.data = data;
          console.log(data);

          vm.telegramIntegration = data.activated;
          setButtonText(vm.telegramIntegration);
          vm.loading = false;
        });
    };
    vm.$onDestroy = function () {
      if (vm.dtInstance) {
        vm.dtInstance.api.destroy();
      }
      vm.dtInstance = undefined;
    };

    function createPermission() {
      $uibModal
        .open({
          animation: false,
          size: 'lg',
          backdrop: 'static',
          bindToController: true,
          component: 'createPermissionModal',
          resolve: {
            customerId: function () {
              return vm.project.customerId;
            },
            permissions: function () {
              return vm.data.permissions;
            },
            projectId: function () {
              return vm.project.id;
            },
          },
        })
        .result.then(function (res) {
          vm.dtInstance.rowData.push(res.permission);
          vm.dtInstance.api.setRowData(vm.dtInstance.rowData);
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function changeTelegramIntegration() {
      //no existe el bot
      vm.activationError = null;
      if (!vm.data.created) {
        vm.loading = true;
        Customer.prototype$__create__projects__telegram({
          id: vm.project.customerId,
          nk: vm.project.id,
        })
          .$promise.then((res) => {
            console.log(res);
            if (res.hashedCode) {
              vm.data.created = true;
              vm.data.working = true;
              vm.data.hashedCode = res.hashedCode;
              vm.data.link = res.link;
              vm.loading = false;
              changeButtonText();
            } else {
              console.log('error');
            }
          })
          .catch((error) => {
            vm.activationError = utils.getHTTPError(error);
            vm.loading = false;
          });
      } else if (vm.data.created) {
        // se activa/desactiva el bot
        vm.loading = true;
        Customer.prototype$__set__projects__telegramActive(
          { id: vm.project.customerId, nk: vm.project.id },
          { active: !vm.data.working }
        )
          .$promise.then((res) => {
            vm.data.working = !vm.data.working;
            vm.loading = false;
            changeButtonText();
          })
          .catch((error) => {
            vm.activationError = utils.getHTTPError(error);
            vm.loading = false;
          });
      }
    }

    function changeButtonText() {
      vm.telegramIntegration = !vm.telegramIntegration;
      setButtonText(vm.telegramIntegration);
    }

    function setButtonText(value) {
      $timeout(function () {
        vm.buttonText = value
          ? $translate.instant('entities.telegram.actions.deactivate')
          : $translate.instant('entities.telegram.actions.activate');
      });
    }

    function initTable(data) {
      data = data || [];

      let gridOptions = {
        suppressCellFocus: true,
        rowData: data,
        pagination: true,
        paginationPageSize: 10,
        sortingOrder: ['desc', 'asc', null],
        domLayout: 'autoHeight',
        getRowId: (params) => {
          return params.data._id;
        },
        columnDefs: [
          {
            sortable: false,
            headerName: $translate.instant('entities.telegram.titles.email'),
            headerTooltip: $translate.instant('entities.telegram.titles.email'),
            field: 'email',
            flex: 3,
            suppressNavigable: true,
            cellRenderer: (params) => {
              return params.data.email;
            },
          },
          {
            sortable: false,
            headerName: $translate.instant('entities.telegram.titles.userName'),
            headerTooltip: $translate.instant('entities.telegram.titles.userName'),
            field: 'telegramUserName',
            flex: 3,
            suppressNavigable: true,
            cellRenderer: (params) => {
              return params.data.telegramUserName;
            },
          },
          {
            sortable: false,
            headerName: $translate.instant('entities.telegram.titles.userType'),
            headerTooltip: $translate.instant('entities.telegram.titles.userType'),
            field: 'userType',
            flex: 2,
            suppressNavigable: true,
            cellRenderer: (params) => {
              return params.data.userType;
            },
          },
          {
            sortable: false,
            headerName: $translate.instant('entities.telegram.titles.state'),
            headerTooltip: $translate.instant('entities.telegram.titles.state'),
            field: 'state',
            flex: 2,
            suppressNavigable: true,
            cellRenderer: (params) => {
              if (params.data.activated) {
                return $translate.instant('entities.telegram.states.activated');
              } else {
                return $translate.instant('entities.telegram.states.noActivated');
              }
            },
          },
          {
            sortable: false,
            headerName: $translate.instant('entities.telegram.titles.actions'),
            headerTooltip: $translate.instant('entities.telegram.titles.actions'),
            field: 'actions',
            flex: 1,
            suppressNavigable: true,
            cellRenderer: (params) => {
              const data = params.data;
              return getActions(data);
            },
          },
        ],
      };

      const target = $element.find('#permission-table')[0];
      vm.dtInstance = AgGridService.newInstance(target, gridOptions).gridOptions;
    }

    function getActions(data) {
      const table = document.createElement('table');
      table.classList.add();
      const row = document.createElement('tr');
      const cell1 = document.createElement('td');
      const btnShow = document.createElement('button');
      btnShow.style.verticalAlign = 'unset';

      if (data.showed) {
        btnShow.classList.add('btn', 'btn-link', 'btn-xs', 'no-padding', 'disabled');
        btnShow.title = $translate.instant('entities.telegram.states.showed');
        btnShow.innerHTML = `<span class="fas fa-fw fa-eye-slash"></span>`;
      } else {
        btnShow.classList.add('btn', 'btn-link', 'btn-xs', 'no-padding');
        btnShow.title = $translate.instant('entities.telegram.actions.showCode');
        btnShow.innerHTML = `<span class="fas fa-fw fa-eye"></span>`;

        btnShow.addEventListener('click', (e) => {
          e.stopPropagation();
          $timeout(() => {
            showPermissionCode(data);
          });
        });
      }

      cell1.appendChild(btnShow);
      row.appendChild(cell1);
      const cell2 = document.createElement('td');
      const btnRemove = document.createElement('button');
      btnRemove.classList.add('btn', 'btn-link', 'btn-xs', 'no-padding');
      btnRemove.title = $translate.instant('entities.telegram.actions.deletePermission');
      btnRemove.innerHTML = `<span class="fas fa-fw fa-trash text-danger"></span>`;
      btnShow.style.verticalAlign = 'unset';

      btnRemove.addEventListener('click', (e) => {
        e.stopPropagation();
        $timeout(() => {
          deletePermissionCode(data);
        });
      });
      cell2.appendChild(btnRemove);
      row.appendChild(cell2);
      table.appendChild(row);

      return table;
    }

    function showPermissionCode(data) {
      $uibModal
        .open({
          animation: false,
          size: 'lg',
          backdrop: 'static',
          bindToController: true,
          windowClass: 'modal-xs modal-warning',
          component: 'telegramPermissionCodeModal',
          resolve: {
            customerId: function () {
              return vm.project.customerId;
            },
            permissionId: function () {
              return data._id;
            },
            projectId: function () {
              return vm.project.id;
            },
          },
        })
        .result.then(function (res) {
          if (res.showed) {
            const permissionIndex = vm.data.permissions.findIndex((item) => item._id === data._id);
            vm.data.permissions[permissionIndex].showed = true;
            vm.dtInstance.api.destroy();
            initTable(vm.data.permissions);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    function deletePermissionCode(permission) {
      $uibModal
        .open({
          animation: false,
          size: 'lg',
          backdrop: 'static',
          windowClass: 'modal-xs modal-warning',
          bindToController: true,
          component: 'telegramDeletePermissionModal',
          resolve: {
            projectId: function () {
              return vm.project.id;
            },
            customerId: function () {
              return vm.project.customerId;
            },
            permission: function () {
              return permission;
            },
          },
        })
        .result.then(function (data) {
          if (data.deleted) {
            const indexToDelete = vm.dtInstance.rowData.findIndex(
              (item) => item._id === permission._id
            );
            if (indexToDelete !== -1) {
              vm.dtInstance.rowData.splice(indexToDelete, 1);
            }
            vm.dtInstance.api.setRowData(vm.dtInstance.rowData);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }

    async function getEmails() {
      return new Promise((resolve, reject) => {
        let adminIds = [];
        let managerIds = [];
        vm.usersEmails = {};
        console.log(vm.data);
        vm.data.permissions.forEach((permission) => {
          if (permission.userType == 'Manager') {
            managerIds.push(permission.vsaasUserId);
          } else {
            adminIds.push(permission.vsaasUserId);
          }
        });

        Customer.prototype$__get__managers({
          id: vm.project.customerId,
          filter: {
            fields: ['id', 'email'],
            where: { id: { inq: managerIds } },
          },
        })
          .$promise.then((managers) => {
            managers.forEach((manager) => {
              vm.usersEmails[manager.id] = manager.email;
            });
            if (adminIds.length > 0) {
              Var.prototype$__get__admins({
                id: $root.user.varId,
                filter: {
                  fields: ['id', 'email'],
                  where: { id: { inq: adminIds } },
                },
              })
                .$promise.then((admins) => {
                  admins.forEach((admin) => {
                    vm.usersEmails[admin.id] = admin.email;
                  });
                  resolve();
                })
                .catch(function (error) {
                  console.log(error);
                });
            } else {
              resolve();
            }
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    }
  }
})();
